export const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user_info") || "null");
    } catch {
        return null;
    }
};

export const getStoredPermissions = () => {
    try {
        const arr = JSON.parse(localStorage.getItem("user_permissions") || "[]");
        // convert array to object keyed by module_key
        const map = {};
        arr.forEach((p) => {
            map[p.module_key] = p;
        });
        return map;
    } catch {
        return {};
    }
};

export const canViewModule = (moduleKey) => {
    const permissions = getStoredPermissions();
    if (!moduleKey) return true;
    return !!permissions?.[moduleKey]?.can_view;
};

export const canCreateModule = (moduleKey) => {
    const permissions = getStoredPermissions();
    return !!permissions?.[moduleKey]?.can_create;
};

export const canUpdateModule = (moduleKey) => {
    const permissions = getStoredPermissions();
    return !!permissions?.[moduleKey]?.can_update;
};

export const canDeleteModule = (moduleKey) => {
    const permissions = getStoredPermissions();
    return !!permissions?.[moduleKey]?.can_delete;
};